
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.2 18.8","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 .6c-.5-.7-1.5-.7-2-.1L.8 7.7c-1 1-1 2.5 0 3.5l7.3 7.2c.5.5 1.3.5 1.8 0s.5-1.3 0-1.8L3.1 9.8c-.3-.3-.3-.7 0-1L9.9 2c.4-.4.5-1 .1-1.4z"}})])
          )
        }
      }
    